import React, { useState, useEffect } from "react";
import Navbar from "../components/navbar";
import "../stylesheets/Nosotros.css";

// 👇 importa las imágenes desde src
import img1 from "../assets/nosotros/Imagen1.jpg";
import img2 from "../assets/nosotros/Imagen2.jpg";

const Nosotros = () => {
  const images = [img1, img2];
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="nosotros-container">
      <Navbar visible={true} />

      <main className="scroll-container">
        {/* HERO */}
        <section
          className="hero-nosotros"
          style={{ backgroundImage: `url(${images[currentImage]})` }}
        >
          <div className="hero-overlay">
            <h1>Conócenos</h1>
            <p>
              Material para cada obra, compromiso en cada entrega.
            </p>
          </div>
        </section>

        {/* QUIÉNES SOMOS */}
        <section className="section quienes-somos">
          <div className="section-content">
            <h2>¿Quiénes Somos?</h2>
            <p>
              Somos tu aliado en cada etapa de la construcción. En SICOR brindamos materiales para todo tipo de obra, con precios accesibles, entregas rápidas y asesoría especializada para que cada producto cumpla con lo que tu proyecto necesita.
            </p>
          </div>
        </section>

        {/* MISIÓN, VISIÓN, VALORES */}
        <section className="section mvv-section">
          <div className="section-content mvv-grid">
            <div className="mvv-card">
              <h3>Misión</h3>
              <p>
                Brindar soluciones tecnológicas accesibles y eficientes que
                contribuyan al crecimiento de nuestros clientes y su entorno.
              </p>
            </div>
            <div className="mvv-card">
              <h3>Visión</h3>
              <p>
                Ser referentes en innovación digital en la región, destacando
                por nuestro compromiso social y la calidad de nuestros proyectos.
              </p>
            </div>
            <div className="mvv-card">
              <h3>Valores</h3>
              <p>
                Honestidad, compromiso, innovación y colaboración son los
                pilares que guían cada paso de nuestro trabajo.
              </p>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="section cta-section">
          <div className="section-content">
            <h2>¿Listo para impulsar tu proyecto?</h2>
            <a href="/contacto" className="btn-cta">
              Contáctanos
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Nosotros;
